// FEATURES-1 (docs/specs/features-1.md): UI gating from the server's runtime switches.
//
// `useFeatureEnabled(key)` is the one way a screen asks "is <feature> on?". It reads
// `GET /v1/features` (the admin portal's switches, already ANDed with "is the infrastructure
// deployed"), so flipping a switch in Admin → Features shows or hides the UI without a rebuild.
// It is `false` while loading or on error: a feature never flashes on before the server says so.
//
// Replaced the per-feature build flags `VITE_FEATURE_ASSISTANT` and `VITE_FEATURE_BUG_REPORTS`
// (Assistant tab/panel, the bug-report provider and its status query now call this). A build
// flag can stay as a forced-OFF override only where a feature must be hidden regardless of the
// server; none needs that today. `VITE_FEATURE_PANELS`
// (lib/featureFlags.ts) is NOT a runtime feature — it previews placeholder UI in dev builds —
// and stays a build flag.
import { useFeatures } from './queries';

/** Registry keys from `backend/src/scribe/features.py`. */
export type FeatureKey =
  | 'assistant'
  | 'mcp'
  | 'transcribe_on_demand'
  | 'bug_reports'
  | 'otter_import'
  | 'live_silence_gating'
  | 'silence_trim'
  | 'whisper'
  | 'voice_prints';

export function useFeatureEnabled(key: FeatureKey): boolean {
  const { data } = useFeatures();
  return data?.[key] === true;
}
